<template>
  <SenseCreditWidget :args="args" />
</template>

<script>
import SenseCreditWidget from '@/components/credits/SenseCreditWidget.vue'

export default {
  name: 'SenseCreditProduct',
  components: {
    SenseCreditWidget,
  },
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data: () => {
    return {
      args: {},
    }
  },
  beforeMount() {
    this.args.merchandises = [
      {
        name: this.product[`name_${this.$i18n.locale}`] || this.product.name,
        code: this.product.code,
        price: this.product.newPrice
          ? this.product.newPrice
          : this.product.price,
        quantity: 1,
      },
    ]
  },
}
</script>
